<template>
  <div class="bundlewWrapper">
    <my-title>Bundels</my-title>

    <div class="columns">
      <div class="column is-three-quarters">
        <div class="field">
          <div class="control">
            <input type="text" class="input" v-model="query" placeholder="Zoek op de naam van de bundel of type het id van de bundel voorafgegaan door een # om alleen op het id te zoeken">
          </div>
        </div>
      </div>

      <div class="column is-one-quarter">
        <create-button
          caption="Nieuwe bundel"
          @click="edit">
        </create-button>
      </div>
    </div>

    <loading-notification
      v-if="isLoading"
      message="De bundels worden geladen">
    </loading-notification>

    <div v-else class="columns">
      <div class="column">
        <table class="table is-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Naam</th>
              <th>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="bundle in myBundles" :key="bundle.id">
              <th>{{ bundle.id }}</th>
              <td>
                <p>{{ bundle.name }}</p>
                <p v-if="bundle.dossier_nr && dossiersLoaded">
                  <span class="tag">
                    <span class="icon">
                      <i class="fas fa-file-alt"></i>
                    </span>

                    {{ getDossierName(bundle.dossier_nr, bundle.profile_nr) }}
                  </span>
                </p>
              </td>

              <td>
                <options-buttons
                  :id="bundle.id"
                  :custom="customButtons"
                  @edit="edit(bundle.id)"
                  @delete="remove(bundle.id)">
                </options-buttons>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <edit-bundle
      :isActive="showEdit"
      @save="save"
      @close="close">
    </edit-bundle>

    <duplicate-bundle
      :fromId="duplicateFromId"
      :isActive="duplicateFromId !== 0"
      @proceed="duplicate"
      @close="toggleDuplicate(0)">
    </duplicate-bundle>

    <sync-values
      :isActive="showSync"
      :sync="sync"
      @submit="handleSync"
      @close="closeSync">
    </sync-values>

    <copy-values
      :isActive="showCopy"
      :copy="copy"
      @save="handleImport"
      @close="closeCopy">
    </copy-values>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import MyTitle from '@/components/modules/Title'
import EditBundle from './EditBundle'
import CopyValues from '@/components/values/CopyValues'
import SyncValues from '@/components/values/SyncValues'
import DossierMixin from '@/mixins/dossiers'
import CreateButton from '@/components/modules/CreateButton'
import OptionsButtons from '@/components/modules/OptionsButtons'
import DuplicateBundle from '@/components/bundles/DuplicateBundle'
import LoadingNotification from '@/components/modules/LoadingNotification'

export default {
  name: 'Bundles',

  components: {
    MyTitle,
    CopyValues,
    EditBundle,
    SyncValues,
    CreateButton,
    OptionsButtons,
    DuplicateBundle,
    LoadingNotification
  },

  mixins: [
    DossierMixin
  ],

  data () {
    return {
      copy: null,
      sync: null,
      showSync: false,
      query: '',
      showEdit: false,
      duplicateFromId: 0,
      customButtons: [{
        icon: 'fas fa-file-import',
        style: '',
        title: 'Basislijsten importeren',
        click: {
          fnc: this.toggleCopy
        }
      },
      {
        icon: 'fas fa-question',
        style: '',
        title: 'Leervragen synchroniseren/importeren',
        click: {
          fnc: this.toggleSync
        }
      },
      {
        icon: 'fas fa-copy',
        style: '',
        title: 'Bundel dupliceren',
        click: {
          fnc: this.toggleDuplicate
        }
      }]
    }
  },

  computed: {
    ...mapGetters({
      bundles: 'bundles/bundles',
      loading: 'bundles/loading',
      dossiers: 'dossiers/dossiers'
    }),

    myBundles () {
      return this.bundles.filter(bundle => {
        if (this.query.charAt(0) === '#') {
          return bundle.id === parseInt(this.query.substr(1))
        }

        const a = `${bundle.id} ${bundle.name.toLowerCase()}`

        return a.includes(this.query.toLowerCase())
      })
    },

    showCopy () {
      return this.copy !== null
    },

    // showSync () {
    //   return this.sync !== null
    // },

    isLoading () {
      return this.loading > 0 && this.loading < 9 && this.dossiers.length === 0
    },

    dossiersLoaded () {
      return this.dossiers.length > 0
    }
  },

  methods: {
    edit (bundleId) {
      this.$store.commit('bundles/RESET')

      if (bundleId) {
        this.$store.dispatch('bundles/load', bundleId)
      }
      this.showEdit = true
    },

    remove (bundleId) {
      this.$store.dispatch('bundles/remove', bundleId)
    },

    save (payload) {
      this.$store.dispatch('bundles/save', payload)
      this.close()
    },

    close () {
      this.showEdit = false
    },

    toggleCopy (targetId) {
      this.copy = {
        to: [targetId]
      }
    },

    toggleSync (targetId) {
      const bundle = this.bundles.find(x => x.id === targetId)

      const dossier = this.getDossier(bundle.dossier_nr)

      if (dossier) {
        this.sync = {
          to: [targetId],
          dossier: dossier,
          profiel: this.getProfile(dossier, bundle.profile_nr)
        }

        this.showSync = true
      }
    },

    toggleDuplicate (fromId) {
      this.duplicateFromId = fromId
    },

    duplicate (payload) {
      this.$store.dispatch('bundles/duplicate', payload)
    },

    handleImport (payload) {
      this.copy.from = payload.bundleId
      this.copy.columns = payload.columns

      this.$store.dispatch('values/copy', this.copy)

      this.closeCopy()
    },

    handleSync (payload) {
      this.sync.from = payload.from
      this.sync.ignoreProfile = payload.ignoreProfile

      this.$store.dispatch('values/sync', this.sync)

      this.closeSync()
    },

    closeCopy () {
      this.copy = null
    },

    closeSync () {
      this.sync = null
      this.showSync = false
    }
  }
}
</script>
